import styled from 'styled-components';
import { Button } from '@/components/UI/Button/Button';

export const Form = styled.form`
  background-color: ${({ theme }) => theme.palette.primary.background};
  padding: 20px 15px;
`;

export const Chips = styled.div`
  margin-top: 15px;
  display: flex;
  gap: 10px;
`;

export const SubmitButton = styled(Button)`
  width: calc(100vw - 30px);
  margin: 0 auto;
`;
